var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { Container, useStyles } from "./style";
import "./style.css";
import { ButtonAFY, GenerateInvoicesAFY, icons, sizes, variants } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
import { Title } from "../../components/layout/style";
var View = function (props) {
    var classes = useStyles();
    var _a = React.useState(props.products), products = _a[0], setProducts = _a[1];
    var _b = React.useState(props.mes), mes = _b[0], setMes = _b[1];
    var _c = React.useState(props.collection), collection = _c[0], setCollection = _c[1];
    var _d = React.useState(props.numberMaximumInvoicesValue), numberMaximumInvoicesValue = _d[0], setNumberMaximumInvoicesValue = _d[1];
    var _e = React.useState(props.cancelAfterValue), cancelAfterValue = _e[0], setCancelAfterValue = _e[1];
    var _f = React.useState(props.numberMaximumValue), numberMaximumValue = _f[0], setNumberMaximumValue = _f[1];
    var _g = React.useState(props.splitArchivesPerProductValue), splitArchivesPerProductValue = _g[0], setSplitArchivesPerProductValue = _g[1];
    var _h = React.useState(props.noCancelExpiredPolicyValue), noCancelExpiredPolicyValue = _h[0], setNoCancelExpiredPolicyValue = _h[1];
    var _j = React.useState(props.noExpiredPolicyAgeValue), noExpiredPolicyAgeValue = _j[0], setNoExpiredPolicyAgeValue = _j[1];
    var _k = React.useState(props.justNewInvoiceNoRebillValue), justNewInvoiceNoRebillValue = _k[0], setJustNewInvoiceNoRebillValue = _k[1];
    var _l = React.useState(props.justRebillNoNewInvoiceValue), justRebillNoNewInvoiceValue = _l[0], setJustRebillNoNewInvoiceValue = _l[1];
    var _m = React.useState(props.type), type = _m[0], setType = _m[1];
    useEffect(function () {
        if (props.products && props.products.length > 0) {
            setProducts(props.products);
        }
    }, [props.products]);
    var onClickBack = function (e) {
        props.onClickBack && props.onClickBack(e);
    };
    useEffect(function () {
        setNumberMaximumInvoicesValue(props.numberMaximumInvoicesValue);
        setCancelAfterValue(props.cancelAfterValue);
        setNumberMaximumValue(props.numberMaximumValue);
        setSplitArchivesPerProductValue(props.splitArchivesPerProductValue);
        setNoCancelExpiredPolicyValue(props.noCancelExpiredPolicyValue);
        setNoExpiredPolicyAgeValue(props.noExpiredPolicyAgeValue);
        setJustNewInvoiceNoRebillValue(props.justNewInvoiceNoRebillValue);
        setJustRebillNoNewInvoiceValue(props.justRebillNoNewInvoiceValue);
        setMes(props.mes);
        setProducts(props.products);
        setCollection(props.collection);
        setType(props.type);
    }, [props]);
    return (_jsxs(React.Fragment, { children: [_jsx(Container, { children: _jsx(ButtonAFY, { variant: variants.text, label: "Regresar", icon: icons.ArrowBackIosNew, size: sizes.small, color: themeCore.colors.primaryText, onClick: onClickBack }) }), _jsxs(Title, { children: [props.title, _jsx("span", __assign({ className: " status ".concat(props.status || "", " ") }, { children: props.estado }))] }), _jsx("div", __assign({ className: "containerPanel", style: { marginTop: "15px" } }, { children: products.length > 0 && (_jsx(GenerateInvoicesAFY, { customHeight: "81vh", backgroundColorBack: themeCore.colors.primary, backgroundColorNext: themeCore.colors.primary, title: "", drawerTitle: "¡Listo!", drawerText: "Se ha enviado la información de facturación a los proyectos seleccionados.", register: null, onClickDefaultValues: props.onClickDefaultValues, onClickNext: props.onClickNext, onClickBack: props.onClickBack, periodLabels: {
                        readOnly: props.readOnly,
                        tipoCobranzaLabel: "Periodo de cobranza",
                        tipoCobranzaValue: type,
                        title: "Periodo de cobranza",
                        cobranzaMonthDateLabel: "Mes de cobranza",
                        maximumLimitLabel: "Límitar máxima cantidad de meses a recobrar",
                        cobranzaMonthDateValue: mes,
                        primePeriodDateLabel: "Periodo de prima",
                        primePeriodStartDateValue: "2021-09-01",
                        primePeriodEndDateValue: "2021-09-30",
                        primeEvaluationDateLabel: "Fecha de evaluación de prima",
                        primeEvaluationDateValue: "2021-09-30",
                        processDateLabel: "Fecha de proceso",
                        processDateValue: "2021-09-30",
                        newCobranzaDateLabel: "Fecha de nueva factura",
                        newCobranzaDateValue: "2021-09-30",
                        recobranzaDateLabel: "Fecha de refacturación",
                        recobranzaDateValue: "2021-09-30",
                        involunteerCancellationDateLabel: "Fecha de cancelación involuntaria",
                        involunteerCancellationDateValue: "2021-09-30",
                        defaultValuesLabel: "Restaurar valores predeterminados",
                        exchangeRateLabel: "Separar archivos por producto",
                        exchangeRateValue: "false",
                        exchangeRateMultiplierLabel: "Multiplicador de tasa de cambio",
                        exchangeRateMultiplierValue: 0,
                        notesLabel: "Opciones de facturación",
                        cancelAfterLabel: "Cancelar la póliza después de (meses)",
                        numberMaximumLabel: "Periodos máximos a cobrar",
                        noRebillLabel: "No recobrar facturas después de",
                        noCancelExpiredPolicyLabel: "No cancelar póliza con pagos vencidos",
                        noExpiredPolicyAgeLabel: "No expirar pólizas por edad",
                        justRebillNoNewInvoiceLabel: "Solo recobranza (no nuevas notas de cobro)",
                        justNewInvoiceNoRebillLabel: "Solo nuevas notas de cobro (no recobranza)",
                        sixMonthsExistingPolicyLabel: "Crear facturas no emitidas de los últimos 6 meses - Póliza existente",
                        sixMonthsNewPolicyLabel: "Crear facturas no emitidas de los últimos 6 meses - Póliza nueva",
                        ignoreLabel: "Ignorar: no procesar controles de facturación de pólizas individuales",
                        numberMaximumInvoicesLabel: "No. máximo de facturas por poliza",
                        maximumLimitInvoicesLabel: "Límite máximo de refacturación",
                        numberMaximumValue: numberMaximumValue,
                        cancelAfterValue: cancelAfterValue,
                        numberMaximumInvoicesValue: numberMaximumInvoicesValue,
                        splitArchivesPerProductValue: splitArchivesPerProductValue,
                        noCancelExpiredPolicyValue: noCancelExpiredPolicyValue,
                        noExpiredPolicyAgeValue: noExpiredPolicyAgeValue,
                        justNewInvoiceNoRebillValue: justNewInvoiceNoRebillValue,
                        justRebillNoNewInvoiceValue: justRebillNoNewInvoiceValue,
                    }, projectsLabels: {
                        title: "Productos a facturar",
                        cobranzaSponsorsLabel: "Facturar todos los Sponsors y productos",
                        selectSponsorLabel: "Seleccionar los Sponsors y productos a facturar",
                        unselectSponsorLabel: "Deseleccionar todo",
                        columns: [
                            {
                                field: "type",
                                headerName: "Código",
                                width: 150,
                                editable: false,
                                flex: 1,
                            },
                            {
                                field: "sponsor",
                                headerName: "Aseguradora",
                                width: 150,
                                editable: false,
                                flex: 1,
                            },
                            {
                                field: "product",
                                headerName: "Producto",
                                width: 150,
                                editable: false,
                                flex: 1,
                            },
                            {
                                field: "currency",
                                headerName: "Moneda",
                                width: 150,
                                editable: false,
                                flex: 1,
                            },
                        ],
                        rows: products,
                    }, next: {
                        nextLabel: props.readOnly ? "" : "Generar",
                        previousLabel: "Cancelar",
                        nextDisabled: false,
                    } })) }))] }));
};
export default View;
